<template>
  <v-container v-if="loaded">
    <h1 class="display-3">Достижения</h1>
    <template v-if="scores.length">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-right">N</th>
              <th class="text-right">Дата</th>
              <th class="text-left">Тест</th>
              <th class="text-right">Результат</th>
              <th class="text-right">Очки</th>
              <th class="text-right">Достижения</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in scores" :key="index">
              <td class="text-right">{{ index + 1 }}</td>
              <td class="text-right">{{ item.date | date }}</td>
              <td>{{ item.test }}</td>
              <td class="text-right">{{ item.result }} / {{ item.size }}</td>
              <td class="text-right">{{ item.score | score }}</td>
              <td class="text-right">
                <p
                  v-for="a in item.achievements"
                  :key="a.sessionId"
                  v-text="a.achievement"
                />
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="4" class="text-right">
                Всего очков:
              </th>
              <th class="text-right">
                {{ total | score }}
              </th>
            </tr>
          </tfoot>
        </template>
      </v-simple-table>
      <p>Ваш уровень: {{ level }}</p>
    </template>
    <template v-else>
      <p>Пока ничего неизвестно про Ваши достижения</p>
    </template>
  </v-container>
  <v-container v-else>
    <v-skeleton-loader
      class="mt-4"
      loading
      tile
      type="heading, table-tbody"
    ></v-skeleton-loader>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'Scores',
  data() {
    return {
      scores: [],
      level: 0,
      total: 0,
      loaded: false
    }
  },
  mounted() {
    this.request('api/scores').then(body => {
      const scores = {}
      body.data.scores.forEach(item => {
        if (!scores[item.sessionId]) {
          scores[item.sessionId] = {
            score: 0,
            date: item.date,
            test: item.test,
            achievements: [],
            size: item.size,
            result: item.result
          }
        }
        scores[item.sessionId].score += item.score
        if (item.achievement) {
          scores[item.sessionId].achievements.push(item)
        }
      })
      this.scores = Object.values(scores).filter(item => item.score)
      this.total = body.data.total
      this.level = body.data.level
      this.loaded = true
    })
  },
  methods: {
    ...mapActions(['request'])
  }
}
</script>
